export const Time = {
  minutesToMilliseconds: (minutes: number) => minutes * 60 * 1000,
  secondsToMilliseconds: (seconds: number) => seconds * 1000,
};
